import React, { useEffect, useState } from 'react'
import './AutoReloadModal.css'

type Props = {
  enabled: boolean
  intervalSeconds: number
  minSeconds: number
  onToggle: (nextValue: boolean) => void
  onIntervalChange: (nextValue: number) => void
}

const AutoReloadModal = ({
  enabled,
  intervalSeconds,
  minSeconds,
  onToggle,
  onIntervalChange,
}: Props) => {
  const [draftEnabled, setDraftEnabled] = useState<boolean>(enabled)
  const [draftInterval, setDraftInterval] = useState<string>(String(intervalSeconds))

  useEffect(() => {
    setDraftEnabled(enabled)
    setDraftInterval(String(intervalSeconds))
  }, [enabled, intervalSeconds])

  const applyInterval = () => {
    const parsed = Number(draftInterval)
    const normalized = Number.isNaN(parsed) ? minSeconds : Math.max(minSeconds, Math.floor(parsed))
    onIntervalChange(normalized)
    setDraftInterval(String(normalized))
  }

  return (
    <div className="auto-reload-modal modal-form">
      <div className="auto-reload-row">
        <label className="auto-reload-toggle" htmlFor="auto-reload-enabled">
          <input
            id="auto-reload-enabled"
            type="checkbox"
            checked={draftEnabled}
            onChange={(event) => {
              const nextValue = event.target.checked
              setDraftEnabled(nextValue)
              onToggle(nextValue)
            }}
          />
          <span>自動更新を有効にする</span>
        </label>
      </div>
      <div className="auto-reload-row">
        <label className="auto-reload-interval" htmlFor="auto-reload-interval">
          更新間隔（秒）
          <input
            id="auto-reload-interval"
            type="number"
            min={minSeconds}
            value={draftInterval}
            onChange={(event) => setDraftInterval(event.target.value)}
            onBlur={applyInterval}
          />
        </label>
        <p className="auto-reload-help">
          最小
          {minSeconds}
          秒で自動更新します。
        </p>
      </div>
    </div>
  )
}

export default AutoReloadModal
